window.chartDetailansichtStruktur = {
	data: {
		struktur: [],
	},

	showLoading() {
		this.chart.showLoading()
	},

	hideLoading() {
		this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.Chart("chart_detailansicht_struktur", {
			chart: {
				type: "pie",
				events: {
					render: function () {
						var chart = this,
							series = chart.series,
							allZeros = true
						for (var i = 0; i < series[0].data.length; i++) {
							if (series[0].data[i].y !== 0) {
								allZeros = false
							}
						}
						if (allZeros) {
							chart.showLoading("Keine Daten vorhanden")
						} else {
							chart.hideLoading()
						}
					},
				},
			},

			tooltip: {
				headerFormat: "",
				pointFormatter: function () {
					return `${this.name}<br/><b>${Highcharts.numberFormat(this.y, 0)}€</b>`
				},
				style: {
					fontSize: chartFontSizeMittel,
					textAlign: "center",
				},
			},

			series: this.seriesStruktur(),
		})
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesStruktur()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	seriesStruktur() {
		return [
			{
				id: "struktur",
				data: this.data.struktur,
			},
		]
	},
}
